import handlebarsHelpers from 'src/utils/handlebar-helpers-list.js';
import { removeLastSlash } from 'src/utils/string';
import { getEnvironment } from 'src/utils/getBaseUrl';
import Handlebars from '../../node_modules/handlebars/dist/handlebars.js';
import cookieStorage from '../js/editor/utils/cookie-storage';

import editorExceptions from './exceptions/editor';

let loadDeferred;

export default class TranslateHelper {
  constructor (namespace, baseUrl, translationsPath, version) {
    this.baseUrl = baseUrl;
    this.version = version;
    this.namespace = namespace;
    this.translationsPath = translationsPath;
    this.setLocale(cookieStorage.get('locale') || 'en');
    this.registeringHelpers();
    this.s3Domain = 'https://s3.amazonaws.com/assets.inkive.com';
  }

  registeringHelpers () {
    Object.entries(handlebarsHelpers).forEach(([key, value]) => {
      Handlebars.registerHelper(key, value);
    });
  }

  getTranslationFileUrl () {
    const environment = getEnvironment();

    if (environment === 'proxy') {
      return `${this.s3Domain}/translations/${this.locale}/${this.namespace}.json`;
    }

    const isBuildOrProductionEnvironment = ['build', 'production'].includes(environment);
    const domain = isBuildOrProductionEnvironment ? removeLastSlash(INKIVE.C.STATIC_URL) : this.s3Domain;
    // Force production to load static translation file until we start creating new translation file for each version again.
    const version = this.version && !isBuildOrProductionEnvironment ? `${this.version}/` : '';

    return `${domain}/assets/build/${version}${this.translationsPath}${this.namespace}.${this.locale}.json?${this.version}`;
  }

  load (locale) {
    if (loadDeferred) return loadDeferred;

    loadDeferred = new Promise((resolve) => {
      locale && this.setLocale(locale);

      const url = this.getTranslationFileUrl();

      fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(response => response.json())
        .then(data => {
          this.data = typeof data === 'string' ? JSON.parse(data) : data;
          return resolve(this.data);
        })
        .catch(() => {
          this.data = {};
          return resolve(this.data);
        });
    });

    return loadDeferred;
  }

  setLocale (locale) {
    this.locale = locale;
    cookieStorage.set('locale', locale);
  }

  lookup (content) {
    content = content.trim().toLowerCase();
    return lookInObject(this.data);

    function lookInObject (obj, path) {
      let knownKey;
      path = path || '';

      Object.values(obj).forEach((val, index) => {
        if (typeof val === 'string' && content === val.trim().toLowerCase()) {
          knownKey = (path ? path + '.' : '') + index;
        }
      });

      if (!knownKey) {
        Object.values(obj).forEach((val, index) => {
          if (typeof val === 'object') {
            knownKey = lookInObject(val, (path ? path + '.' : '') + index);
          }
        });
      }

      return knownKey;
    }
  }

  translate (key, data) {
    if (!key) return;

    let index;
    let path = this._map(key);
    let currentPath = this.data;

    path = path ? path.split('.') : [];

    while (path.length && currentPath) {
      index = path.shift();
      currentPath = currentPath[index];
    }

    if (currentPath) {
      return (data || currentPath.indexOf('{{#') > -1)
        ? translateTemplate.call(this, currentPath, data)
        : currentPath;
    }

    errorLog();

    return key;

    function translateTemplate (source, data) {
      const options = {
        knownHelpers: Object.keys(handlebarsHelpers)
      };
      const template = Handlebars.compile(source, options);
      data = _.isArray(data) ? getDataFromArray(data, source) : data;

      return template(data);
    }

    function getDataFromArray (data, source) {
      const dataObject = {};
      const handlebarVariableRegex = /{{{?[\s]*([^#|}|/|\s]+)[\s]*}?}}/g;
      const variableNames = [...source.matchAll(handlebarVariableRegex)].map(m => m[1]);

      while (variableNames.length && data.length) { dataObject[variableNames.pop()] = data.pop(); }

      return dataObject;
    }

    function errorLog () {
      const baseUrl = BASE_URL || INKIVE.C.BASE_URL;
      const isDevOrStaging = baseUrl.indexOf('.xyz') > -1;
      const isOptionalTranslation = key.indexOf('popupmenu') === 0 ||
            key.indexOf('advice.more') === 0 ||
            key.indexOf('advice.title') === 0;

      if (!isOptionalTranslation && isDevOrStaging) {
        if (!window.translationsLogs) { window.translationsLogs = {}; }

        if (!window.translationsLogs[key]) {
          window.translationsLogs[key] = new Date();
          $.post(baseUrl + 'api/errortrack/log', {
            data: '[TranslateHelper] ' + key,
            is_critical: true
          });
        }
      }
    }
  }

  _map (key) {
    return editorExceptions ? editorExceptions(key) : key;
  }
}
